<template>
  <div>
    <el-form
      ref="form"
      :model="form"
      label-width="40px"
    >
      <el-form-item label="姓名">
        <el-input
          v-model="form.name"
          placeholder="请输入专家姓名"
          @input="change"
        ></el-input>
      </el-form-item>
      <el-form-item label="性别">
        <el-input
          v-model="form.sex"
          placeholder="请输入专家性别"
          @input="change"
        ></el-input>
      </el-form-item>
      <el-form-item label="地区">
        <el-input
          v-model="form.address"
          placeholder="请输入专家地区"
          @input="change"
        ></el-input>
      </el-form-item>
      <el-form-item label="医院">
        <el-input
          v-model="form.hospitalName"
          placeholder="请输入专家医院"
          @input="change"
        ></el-input>
      </el-form-item>
      <el-form-item label="科室">
        <el-input
          v-model="form.department"
          placeholder="请输入专家科室"
          @input="change"
        ></el-input>
      </el-form-item>
      <el-form-item label="职称">
        <el-input
          v-model="form.title"
          placeholder="请输入专家职称"
          @input="change"
        ></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script type="text/ecmascript-6">
import mixins from "./mixins";

export default {
  name: "customMDTSpecialist",
  data() {
    return {
      form: {},
    };
  },
  mixins: [mixins],
  components: {},
  methods: {
    change() {
      const { form } = this;
      const answer = `
        姓名：${form.name},性别：${form.sex},地区：${form.address},医院：${form.hospitalName},科室：${form.department},职称：${form.title},`;
      this.answerChange(answer);
    },
  },
};
</script>

<style scoped lang="less">
</style>
